<template>
  <view class="pft-clock-component" flex="dir:left main:center cross:center" :style="style">
    <view class="blink-container">
      <view :class="{ blink: true, active: blink }"></view>
    </view>
    <view class="clock-date" flex="dir:left main:center cross:center">
      <view class="year">{{ year }}</view>
      <view class="seperat">-</view>
      <view class="month">{{ month }}</view>
      <view class="seperat">-</view>
      <view class="day">{{ day }}</view>
    </view>
    <view class="clock-time" flex="dir:left main:center cross:center">
      <view class="hour">{{ hour }}</view>
      <view class="seperat">:</view>
      <view class="minute">{{ minute }}</view>
      <view class="seperat">:</view>
      <view class="second">{{ second }}</view>
    </view>
  </view>
</template>

<script lang="ts" setup>
import { ref } from "vue"
import moment from "moment"
interface ClockProps {
  style?: { [key: string]: string }
}

withDefaults(defineProps<ClockProps>(), {
  style: () => ({}),
})

const date = ref(moment())
const blink = ref(true)

const year = ref(date.value.format("YYYY"))
const month = ref(date.value.format("MM"))
const day = ref(date.value.format("DD"))
const hour = ref(date.value.format("HH"))
const minute = ref(date.value.format("mm"))
const second = ref(date.value.format("ss"))

setInterval(() => {
  blink.value = !blink.value
}, 500)
setInterval(() => {
  date.value = moment()
  year.value = date.value.format("YYYY")
  month.value = date.value.format("MM")
  day.value = date.value.format("DD")
  hour.value = date.value.format("HH")
  minute.value = date.value.format("mm")
  second.value = date.value.format("ss")
}, 1000)
</script>

<style lang="scss">
.pft-clock-component {
  font-size: 16px;
  position: relative;
  .blink-container {
    margin-right: 32px;
    .blink {
      position: absolute;
      top: 10px;
      left: 0;
      width: 12px;
      height: 4px;
      background-color: #ffc43a;
      animation: blink 1s infinite;
    }
    .active {
      background-color: transparent;
    }
  }
  .clock-date {
    font-family: Arial, Arial;
    font-weight: 400;
    font-size: 20px;
    color: #17d1ff;
    .seperat {
      margin: 0 5px;
    }
  }
  .clock-time {
    font-family: Arial, Arial;
    font-weight: 400;
    font-size: 20px;
    color: #17d1ff;
    margin-left: 20px;
    .seperat {
      margin: 0 5px;
    }
  }
}
</style>
